// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fPAnV6HgzZIVmxvfEGG8aw\\=\\={text-underline-offset:.3rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"underlineOffset": "fPAnV6HgzZIVmxvfEGG8aw=="
};
module.exports = ___CSS_LOADER_EXPORT___;
